import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12
    }
  },
  dialogTitle: {
    padding: spacing(3, 3, 1, 3)
  },
  title: {
    fontWeight: 600
  },
  subtitle: {
    marginTop: spacing(1),
    fontSize: '0.875rem',
    lineHeight: 1.4
  },
  dialogContent: {
    padding: spacing(3, 3)
  },
  formField: {
    marginTop: spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 8
    },
    '& .MuiInputLabel-root': {
      backgroundColor: palette.background?.paper || '#fff',
      padding: spacing(0, 1)
    }
  },
  dialogActions: {
    padding: spacing(2, 3, 3, 3),
    gap: spacing(2)
  }
}))
